import * as PIXI from 'pixi.js'
import gsap from 'gsap'
import { App } from '@system/App'
import { extractNumber } from '@utils/helpers'


 
export type LabelType = 'horizontal' | 'vertical'


export class Label {
    continer: PIXI.Container = new PIXI.Container()
    text: PIXI.Text | null = null
    dash: PIXI.Graphics | null = null
    x: number
    y: number
    graph: PIXI.Container
    type: LabelType
    content: string
    startX: number
    startY: number
    private animationTween: gsap.core.Tween | null = null;
    animate: boolean = false
    xLabelsNumber=0
    yLabelsNumber=0

    constructor(x: number, y: number, graphContainer: PIXI.Container, type: LabelType, content: string, startX: number, startY: number, xLabelsNumber:number,yLabelsNumber:number) {
        this.x = x
        this.y = y
        this.startX = startX
        this.startY = startY
        this.continer.position.set(x, y)
        this.graph = graphContainer
        this.type = type
        this.content = content
        this.xLabelsNumber = xLabelsNumber
        this.yLabelsNumber = yLabelsNumber
      
        // Calculate dynamic font size
        const baseFontSize = 60; // Base font size for reference
        const fontSizeFactor = 0.7; // Factor to scale font size (adjust as needed)
        const newFontSize = Math.max(baseFontSize * (App.app.renderer.width / 1920) * fontSizeFactor, 7);

        this.text = new PIXI.Text({ text: content, style: { fontFamily: "\"Barlow\", \"sans-serif\"", fontSize: newFontSize, fill: 0x000000, fontWeight: '500' } })
        
 


        this.dash = new PIXI.Graphics()

      

        if (type === 'horizontal') {
            this.resizeXDash()
            this.text.anchor.set(0.5, 0)
           this.positionXLabe()
            
        } else {
           this.resizeYDash()
            this.positionYLabe()
            this.text.anchor.set(1, 0.5)
          
        }
    


        this.continer.addChild(this.text)
        if (content !== '0') {
            this.continer.addChild(this.dash)
        }
    }



    positionYLabe(){
        this.text!.x = this.continer.x + this.startX   - 10/100 * (this.continer.x + this.startX ) 
    }
    positionXLabe(){
        const percant = window.innerWidth > 1400 ? 50/100 : 80/100
        this.text!.y =-percant*(this.continer.y - this.startY)
    }

    resizeXDash(){
        const length = window.innerWidth >1400 ? 7 : 3.5
        this.dash?.clear()
        this.dash!.moveTo(0, this.startY - this.continer.y);
        this.dash!.lineTo(0, this.startY - this.continer.y -length)
        this.dash!.stroke({ width: 1, color: 0x383838 })
    }

    resizeYDash(){
        const length = window.innerWidth >1400 ? 7 : 3.5
        this.dash?.clear()
        this.dash!.moveTo( this.startX  , 0);
        this.dash!.lineTo(   this.startX + length, 0)
        this.dash!.stroke({ width: 1, color: 0x383838 })
    }


    startAnimation(index: number) {
        if (!this.animate) {
            this.animate = true
            if (this.type === 'horizontal') {
        
                const duration = +this.text!.text < 20 ? 30 : 100;
                const fn = +this.text!.text < 20 ? "power1.out"  :
                +this.text!.text >= 20 ? "power2.out" :
                "power2.out";
                
                this.animationTween = gsap.to(this.continer, { x: this.startX, duration:duration,ease:fn});
            } else {
              
                this.animationTween = gsap.to(this.continer, { y: this.startY, duration:40, ease: "power3.out" });
            }
        }

    }

    stopAnimation() {
        if (this.animationTween) {
            this.animationTween.kill();
        }
    }


    pauseAnimation() {
        if (this.animationTween) {
            this.animationTween.pause();
        }
    }


    // Method to be called to remove the label
    remove() {
        this.stopAnimation();
        this.graph.removeChild(this.continer);
        this.continer.destroy()
    }
}

